document.addEventListener('alpine:init', () => {
  Alpine.data('gatedContentHero', () => ({
    async play() {
      const match = this.$refs.videoContainer.dataset.vimeo.match(/([0-9]+)(?:\/([0-9a-z]+)|$)?/i);

      if (match) {
        await new Promise((resolve) => {
          this.$refs.videoContainer.addEventListener('next', () => resolve(), {
            once: true,
          });
          this.$refs.videoContainer.innerHTML += `<iframe @load="$dispatch('next')" src="https://player.vimeo.com/video/${
            match[1]
          }?${
            match[2] ? `h=${match[2]}&` : ''
          }&autoplay=1&title=0&byline=0&portrait=0" class="block w-full h-full" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe><script src="https://player.vimeo.com/api/player.js"></script>`;

          this.$refs.playButton.classList.add('opacity-0', 'invisible');
        });
      }
    },
  }));
});